<template>
    <div class="check-address-item" @click="handleAdd">
        <div class="address-item__send" :class="type==='send'?'address-item__send':'address-item__accept'">
            <div class="address-info">
                <span class="address-info__name">{{shou}}件人信息</span> &nbsp;&nbsp;&nbsp;
            </div>
            <div class="address-detail address-detail">
                <span class="address-detail__address">点击填写{{shou}}件人相关信息</span>
                <div class="address-btn" @click.stop="handleClick">
                    <span class="address-btn__del"></span>
                    <span class="address-btn__contact" :class="'address-icon__contact-' + type"></span>
                    <span class="directory_inquiries" :class="'directory_inquiries_'+type">地址簿</span>
                </div>
            </div>

        </div>
    </div>
</template>
<script>
    export default {
        name: "defaultAddressItem",
        props: {
            type: {
                type: String,
                default: 'send'
            },
            shou: {
                shou: String,
            }
        },

        methods: {
            handleClick() {
                this.$emit('click')
            },
            handleAdd() {
                if (this.type === 'send') {
                    this.$router.push("/sendAddress/add");
                } else {
                    this.$router.push("/acceptAddress/add");
                }
            },
        }
    }
</script>


<style scoped lang="scss">
    .check-address-item {
        width: 100%;

        & ~ .check-address-item {
            margin-top: 1px;
        }
    }

    .address-info {
        color: #2E2E2E;
        font-size: 0.48rem;
        font-weight: bold;
        display: flex;
        flex-direction: row;
        align-items: center;

        .address-info__name {
            white-space: nowrap;
            text-overflow: ellipsis;
            overflow: hidden;
        }
    }

    .address-detail__address {
        height: .85rem;
        font-size: 0.4rem;
        color: #777777;
    }

    .address-btn {
        flex: 1;
        display: flex;
        flex-direction: row;
        justify-content: space-around;
        height: 100%;
        width: 2.613333rem;
        position: relative;

        .directory_inquiries_send{
            color: #234781;
        }
        .directory_inquiries_accept{
            color: #fea044;
        }

        &__del {
            position: relative;
            width: 0.51rem;
            height: 0.51rem;

            &::after {
                content: '';
                position: absolute;
                height: 100%;
                border-right: 1px solid #e5e5e5;
                right: -0.3rem;
            }
        }

        &__contact {
            position: absolute;
            top: -0.40rem;
            right: 0.45rem;
            width: 0.53rem;
            height: 0.53rem;
            background: url('../../../assets/contact-send.png') center / 100% no-repeat;

        }
    }

    .address-item__send, .address-item__accept {
        background: #ffffff;
        padding: 0.3rem 0.32rem 0.3rem 1.2rem;
        position: relative;
        width: 100%;
        height: 2.67rem;
        box-sizing: border-box;

        .address-info {
            width: 70%;
        }

        &:before {
            content: '';
            height: 0.73rem;
            width: 0.73rem;
            position: absolute;
            left: 0.32rem;
            top: 50%;
            transform: translateY(-50%);
            background: url('../../../assets/send.png') center / 100% no-repeat;
        }

        .address-detail {
            display: flex;
            flex-direction: row;
            align-items: center;
            justify-content: space-between;

            &__address {
                width: 70%;
            }
        }

        .address-options {
            display: flex;
            flex-direction: row;
            color: #042D6F;
            font-size: 0.35rem;
            line-height: 0.4rem;
            height: 0.4rem;
            margin-top: 0.266666rem;

            &__item {
                flex: 1;
                text-align: center;

                &:nth-child(1) {
                    text-align: left;
                }

                &:nth-last-child(1) {
                    text-align: right;
                }
            }
        }
    }

    .address-item__accept {
        &:before {
            content: '';
            height: 0.73rem;
            width: 0.73rem;
            position: absolute;
            left: 0.32rem;
            top: 50%;
            transform: translateY(-50%);
            background: url('../../../assets/accept.png') center / 100% no-repeat;
        }

        .address-btn__contact {
            position: absolute;
            top: -0.40rem;
            right: 0.45rem;
            width: 0.53rem;
            height: 0.53rem;
            background: url('../../../assets/contact-accept.png') center / 100% no-repeat;
        }
    }

    .directory_inquiries {
        position: relative;
        top: 0.40rem;
        left: 0.08rem;
    }


</style>
